import axios from './axios';

export default {
  list() {
    return axios.get('/subscriptions');
  },
  get(subscriptionId) {
    return axios.get(`/subscriptions/${subscriptionId}`);
  },
  delete(subscriptionId) {
    return axios.delete(`/subscriptions/${subscriptionId}`);
  },
};
